function chr4(): string {
	return Math.random().toString(16).slice(-4);
}

export function createUuid4(prefix: string): string {
	return `${prefix}-${chr4()}${chr4()}-${chr4()}-${chr4()}-${chr4()}-${chr4()}${chr4()}${chr4()}`;
}
